import { recoverBasicInfo } from './recover-basic-info';
import { recoverCurrentAddress } from './recover-current-address';

import type { PersonData, PersonDataResponse } from '../../model';

const personRecoverers = {
  basicInfo: recoverBasicInfo,
  currentAddress: recoverCurrentAddress,
};

export function recoverPersonValues(data: PersonDataResponse): PersonData {
  return Object.entries(personRecoverers).reduce<PersonData>(
    (acc, [key, recover]) => ({ ...acc, [key]: recover(data) }),
    {} as PersonData
  );
}
